import { createRouter, createWebHistory } from 'vue-router';
import { createAppRoutes, citizenFixedRoutes } from '@onify/helix-core/citizen-runtime';
import { helixSettings } from '../../.helix/settings';

const routes = createAppRoutes(citizenFixedRoutes, helixSettings);

// Redirect /admin to /admin/dashboard so the bare path doesn't 404
routes.unshift({ path: '/admin', redirect: '/admin/dashboard' });

const router = createRouter({
  history: createWebHistory(import.meta.env.HELIX_BASE_URL),
  routes,
  scrollBehavior(_to, _from, _savedPosition) {
    return { top: 0 };
  },
});

router.beforeEach(themeGuard);
router.beforeEach(maintenanceGuard);
router.beforeEach(adminGuard);

export { router };
